import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { onOutsideClick, toggle, togglePropTypes } from 'lp-hoc'
import classnames from 'classnames'
import { startCase } from 'lodash'
import { useUID } from 'react-uid'

const propTypes = {
  ...togglePropTypes('expanded'),
  text: PropTypes.string,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  placeholder: PropTypes.string,
  triggerAriaLabel: PropTypes.string.isRequired,
}

const defaultProps = {
  selectedValues: [],
  placeholder: 'None',
}

function DropdownSelect({
  toggleExpanded,
  expanded,
  selectedValues,
  children,
  placeholder,
  triggerAriaLabel,
}) {
  const optionsId = useUID()

  return (
    <div className="dropdown-select">
      <button
        type="button"
        className="select-input"
        onClick={toggleExpanded}
        aria-expanded={expanded}
        aria-controls={optionsId}
        aria-label={triggerAriaLabel}
      >
        <p>{getLabel(selectedValues, placeholder)}</p>
      </button>
      <div
        id={optionsId}
        className={classnames('options checkboxes', { 'is-active': expanded })}
      >
        <div className="scroll-box">{children}</div>
      </div>
    </div>
  )
}

export function getLabel(values, placeholder) {
  return values.length
    ? values.map((value) => startCase(value)).join(', ')
    : placeholder
}

DropdownSelect.propTypes = propTypes

DropdownSelect.defaultProps = defaultProps

function handleClickOutside({ setExpanded }) {
  return setExpanded(false)
}

export default compose(
  toggle('expanded'),
  onOutsideClick(handleClickOutside)
)(DropdownSelect)
